import Vue from 'vue'
import Router from 'vue-router'


const privacyPolicy = () => import('@/pages/privacyPolicy')
const termOfUse = () => import('@/pages/termOfUse')
const cookiePolicy = () => import('@/pages/cookiePolicy')

const empty = () => import('@/pages/empty')
const patternLockTest = () => import('@/pages/patternLockTest')


const homePage = () => import('@/pages/homePage')
const leaderboardPage = () => import('@/pages/leaderboardPage')
const comicPage = () => import('@/pages/comicPage')

const faqPage = () => import('@/pages/faqPage')
const accountPage = () => import('@/pages/accountPage')
const kwodexPage = () => import('@/pages/kwodexPage')
const chapter1 = () => import('@/pages/chapter1')
const chapter2 = () => import('@/pages/chapter2')
const chapter3 = () => import('@/pages/chapter3')



// import faqPage from '@/pages/faqPage'
// import accountPage from '@/pages/accountPage'
// import kwodexPage from '@/pages/kwodexPage'
// import chapter1 from '@/pages/chapter1'
// import chapter1Backup from '@/pages/chapter1Backup'
// import chapter2 from '@/pages/chapter2'
// import chapter3 from '@/pages/chapter3'

// import unityPageTest from '@/pages/unityPageTest'
// import animationPageTest from '@/pages/animationPageTest'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: homePage
    },
    {
      path: '/comic',
      name: 'comicPage',
      component: comicPage
    },
    {
      path: '/leaderboard',
      name: 'leaderboardPage',
      component: leaderboardPage
    },
    {
      path: '/faq',
      name: 'faqPage',
      component: faqPage
    },
    {
      path: '/account',
      name: 'accountPage',
      component: accountPage
    },
    {
      path: '/kwodex',
      name: 'kwodexPage',
      component: kwodexPage
    },
    {
      path: '/comic/chapter1',
      name: 'chapter1',
      component: chapter1
    },
    {
      path: '/comic/chapter2',
      name: 'chapter2',
      component: chapter2
    },
    {
      path: '/comic/chapter3',
      name: 'chapter3',
      component: chapter3
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },
    {
      path: '/termOfUse',
      name: 'termOfUse',
      component: termOfUse
    },
    {
      path: '/cookiePolicy',
      name: 'cookiePolicy',
      component: cookiePolicy
    },



    // test
    // {
    //   path: '/comic/chapter3',
    //   name: 'chapter3',
    //   component: chapter3
    // },
    // {
    //   path: '/comic/007cbfbdd61a747ac3df1244833ebba8',
    //   name: 'chapter3',
    //   component: chapter3
    // },


    
    // {
    //   path: '/empty',
    //   name: 'empty',
    //   component: empty
    // },
    {
      path: '/patternLockTest',
      name: 'patternLockTest',
      component: patternLockTest
    },
    // {
    //   path: '/unityPageTest',
    //   name: 'unityPageTest',
    //   component: unityPageTest
    // },
    // default
    {
      path: '/*',
      name: 'homepageDefault',
      component: homePage
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js